module.exports = __webpack_public_path__ + "static/img/volkswagen-competition.be36867.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/volkswagen-competition.jpg
// module id = 1n8s
// module chunks = 0